import axios from 'axios';
import { Encrypt } from '../utils/encryption';
import { userManagementApi } from '../config/api';

const headers = { 'Content-Type': 'application/json' };

async function post(operationType, payload) {
  const res = await axios.post(
    userManagementApi,
    { ...Encrypt(payload), operationType },
    { headers }
  );
  return res.data;
}

export function listTeamMembers(token) {
  return post('listTeamMembers', { token });
}

export function addTeamMembers(token, fields) {
  return post('addTeamMembers', {
    token,
    firstName: fields.firstName,
    lastName: fields.lastName,
    userName: fields.userName,
    password: fields.password,
  });
}

export function removeTeamMembers(token, memberPk) {
  return post('removeTeamMembers', { token, memberPk });
}

export function resignTeamMember(token) {
  return post('resignTeamMember', { token });
}
